var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-table" },
    [
      _c(
        "b-tabs",
        {
          attrs: {
            size: "is-medium",
            type: "is-toggle",
            expanded: "",
            multiline: "",
          },
        },
        [
          _vm.files.plans
            ? _c("b-tab-item", { attrs: { label: "Plans" } }, [
                _vm.files.plans.length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [_vm._v("No plans uploaded for this project")]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.plans,
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.files.annotatedPlans
            ? _c("b-tab-item", { attrs: { label: "Annotated Plans" } }, [
                _vm.files.annotatedPlans.length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "No annotated plans uploaded for this project"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.annotatedPlans,
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.files.builderReports
            ? _c("b-tab-item", { attrs: { label: "Builder" } }, [
                Object.keys(_vm.files.builderReports).length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [_vm._v("No reports uploaded for this project yet")]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "dropdown-container" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "is-align-self-flex-end mb-4",
                            attrs: { size: "is-medium", "aria-role": "list" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "trigger",
                                  fn: function (ref) {
                                    var active = ref.active
                                    return [
                                      _c("b-button", {
                                        attrs: {
                                          size: "is-medium",
                                          label: _vm.selectedBuilderPlot
                                            ? "Plot - " +
                                              _vm.title(_vm.selectedBuilderPlot)
                                            : "Select Plot",
                                          type: "is-accent",
                                          "icon-right": "caret-down",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              215699807
                            ),
                          },
                          [
                            _vm._v(" "),
                            _vm._l(
                              _vm.files.builderReports,
                              function (reports, index) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedBuilderPlot = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Plot - " +
                                        _vm._s(_vm._f("title")(index)) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.selectedBuilderPlot &&
                _vm.files.builderReports[_vm.selectedBuilderPlot] &&
                _vm.files.builderReports[_vm.selectedBuilderPlot].length > 0
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.builderReports[
                                _vm.selectedBuilderPlot
                              ],
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "File Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : Object.keys(_vm.files.builderReports).length > 1
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "Please select a plot using the above dropdown to see the\n            reports for it"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.files.clientReports
            ? _c("b-tab-item", { attrs: { label: "Client" } }, [
                Object.keys(_vm.files.clientReports).length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "No client reports uploaded for this project yet"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "dropdown-container" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "is-align-self-flex-end mb-4",
                            attrs: { size: "is-medium", "aria-role": "list" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "trigger",
                                  fn: function (ref) {
                                    var active = ref.active
                                    return [
                                      _c("b-button", {
                                        attrs: {
                                          size: "is-medium",
                                          label: _vm.selectedClientPlot
                                            ? "Plot - " +
                                              _vm.title(_vm.selectedClientPlot)
                                            : "Select Plot",
                                          type: "is-accent",
                                          "icon-right": "caret-down",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              483442495
                            ),
                          },
                          [
                            _vm._v(" "),
                            _vm._l(
                              _vm.files.clientReports,
                              function (reports, index) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedClientPlot = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Plot - " +
                                        _vm._s(_vm._f("title")(index)) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.selectedClientPlot &&
                _vm.files.clientReports[_vm.selectedClientPlot] &&
                _vm.files.clientReports[_vm.selectedClientPlot].length > 0
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.clientReports[
                                _vm.selectedClientPlot
                              ],
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "File Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : Object.keys(_vm.files.clientReports).length > 1
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "Please select a plot using the above dropdown to see the\n            reports for it"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.files.branchReports
            ? _c("b-tab-item", { attrs: { label: "Branch" } }, [
                Object.keys(_vm.files.branchReports).length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "No branch reports uploaded for this project yet"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "dropdown-container" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "is-align-self-flex-end mb-4",
                            attrs: { size: "is-medium", "aria-role": "list" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "trigger",
                                  fn: function (ref) {
                                    var active = ref.active
                                    return [
                                      _c("b-button", {
                                        attrs: {
                                          size: "is-medium",
                                          label: _vm.selectedBranchPlot
                                            ? "Plot - " +
                                              _vm.title(_vm.selectedBranchPlot)
                                            : "Select Plot",
                                          type: "is-accent",
                                          "icon-right": "caret-down",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3682987167
                            ),
                          },
                          [
                            _vm._v(" "),
                            _vm._l(
                              _vm.files.branchReports,
                              function (reports, index) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedBranchPlot = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Plot - " +
                                        _vm._s(_vm._f("title")(index)) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.selectedBranchPlot &&
                _vm.files.branchReports[_vm.selectedBranchPlot] &&
                _vm.files.branchReports[_vm.selectedBranchPlot].length > 0
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.branchReports[
                                _vm.selectedBranchPlot
                              ],
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "File Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : Object.keys(_vm.files.branchReports).length > 1
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "Please select a plot using the above dropdown to see the\n            reports for it"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.files.externalQuotes
            ? _c("b-tab-item", { attrs: { label: "Specialist Quotes" } }, [
                Object.keys(_vm.files.externalQuotes).length <= 0
                  ? _c("div", [
                      _c("div", { staticClass: "notification is-primary" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-5 primary-font-color has-text-centered",
                          },
                          [
                            _vm._v(
                              "No specialist quotes uploaded for this project"
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "dropdown-container" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "is-align-self-flex-end mb-4",
                            attrs: { size: "is-medium", "aria-role": "list" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "trigger",
                                  fn: function (ref) {
                                    var active = ref.active
                                    return [
                                      _c("b-button", {
                                        attrs: {
                                          size: "is-medium",
                                          label: _vm.selectedExternalQuote
                                            ? "Specialist Quote - " +
                                              _vm.title(
                                                _vm.selectedExternalQuote
                                              )
                                            : "Select Specialist Quote",
                                          type: "is-accent",
                                          "icon-right": "caret-down",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              971940127
                            ),
                          },
                          [
                            _vm._v(" "),
                            _vm._l(
                              _vm.files.externalQuotes,
                              function (reports, index) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedExternalQuote = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Specialist Quote - " +
                                        _vm._s(_vm._f("title")(index)) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.selectedExternalQuote &&
                _vm.files.externalQuotes[_vm.selectedExternalQuote] &&
                _vm.files.externalQuotes[_vm.selectedExternalQuote].length > 0
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c(
                          "b-table",
                          {
                            ref: "table",
                            attrs: {
                              data: _vm.files.externalQuotes[
                                _vm.selectedExternalQuote
                              ],
                              striped: "",
                              paginated: "",
                              hoverable: "",
                              "per-page": "8",
                              "aria-next-label": "Next page",
                              "aria-previous-label": "Previous page",
                              "aria-page-label": "Page",
                              "aria-current-label": "Current page",
                              "pagination-position": "bottom",
                            },
                          },
                          [
                            _c("b-table-column", {
                              attrs: {
                                label: "Quote Type",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("title")(
                                                  _vm.selectedExternalQuote
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1540899618
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "File Name",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "cell-element" },
                                          [
                                            !_vm.deviceIsMobile
                                              ? _c("file-icon", {
                                                  attrs: { file: props.row },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(props.row.name) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2050716405
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: "Uploaded",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("dateLong")(
                                                  props.row.modifiedTime
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                287832610
                              ),
                            }),
                            _vm._v(" "),
                            _c("b-table-column", {
                              attrs: {
                                label: " ",
                                "th-attrs": _vm.columnThAttr,
                                "td-attrs": _vm.columnTdAttrs,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(
                                                  props.row.id,
                                                  props.row.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isLoading(props.row.id)
                                              ? _c("fa", {
                                                  attrs: {
                                                    icon: "cloud-arrow-down",
                                                  },
                                                })
                                              : _c("fa", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                330897697
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }